import { DIALOG_DATA, Dialog, DialogRef } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

export interface DeleteAppointmentModalComponentData {}

export interface DeleteAppointmentModalComponentResult {
  isDeleted: boolean;
}

@Component({
  selector: 'lib-delete-appointment-modal',
  imports: [CommonModule, TranslateModule],
  templateUrl: './delete-appointment-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteAppointmentModalComponent {
  public dialogData: DeleteAppointmentModalComponentData = inject(DIALOG_DATA);
  public dialog = inject(Dialog);
  private readonly dialogRef = inject(DialogRef);

  public onCloseDialog(): void {
    this.dialogRef.close({ isDeleted: false });
  }

  public onDeleteAppointmentClick(): void {
    this.dialogRef.close({ isDeleted: true });
  }
}
